module.exports = __webpack_public_path__ + "img/communication.eeac4098.svg";